export const typeGuard = <T>(value: any, values: readonly T[]): value is T => values.includes(value);
